import { render, staticRenderFns } from "./CouponIssueManagement.vue?vue&type=template&id=cc1e0c7c&scoped=true"
import script from "./CouponIssueManagement.vue?vue&type=script&lang=js"
export * from "./CouponIssueManagement.vue?vue&type=script&lang=js"
import style0 from "./CouponIssueManagement.vue?vue&type=style&index=0&id=cc1e0c7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1e0c7c",
  null
  
)

export default component.exports